import React from 'react';

const OxygenDeviceCard = ({ device, onClick }) => {

  return (
    <div className="pt-2 card mb-4 border-0 shadow-lg rounded-4 overflow-scroll" style={{ cursor: 'pointer', height:"875px" }}>
      
      <img
        src={device?.mainPhoto}
        alt={device?.deviceName}
        className="img-fluid"
        style={{ objectFit: 'contain', height: '350px', width: '100%', padding: '0 10px' }}
      />
     
      <div className="p-4">
        <h5 className="fw-bold text-dark py-2">{device?.deviceName}</h5>
        <p className="mb-2 fw-semibold border-bottom pb-2">Device Specifications</p>

        <ul className="list-unstyled small fw-semibold">
          <li style={{ marginTop: '5px', paddingBottom: '5px' }}><strong>RAM + Storage:</strong> {device?.deviceRam} + {device?.storage}</li>
          <li style={{ marginTop: '5px', paddingBottom: '5px' }}><strong>Screen Size:</strong> {device?.screenSize}</li>
          <li style={{ marginTop: '5px', paddingBottom: '5px' }}><strong>Battery:</strong> {device?.battery}</li>
          <li style={{ marginTop: '5px', paddingBottom: '5px' }}><strong>OS:</strong> {device?.osUi}</li>
          <li style={{ marginTop: '5px', paddingBottom: '5px' }}><strong>Chipset:</strong> {device?.chipset}</li>
          <li  style={{ marginTop: '5px', paddingBottom: '5px' }}><strong>Camera:</strong> {device?.camera}</li>
          <li style={{ marginTop: '5px', paddingBottom: '5px' }}><strong>Weight:</strong> {device?.weight}</li>
          <li style={{ marginTop: '5px', paddingBottom: '5px' }}><strong>Dimensions:</strong> {device?.dimension}</li>
          {/* <li style={{ marginTop: '5px', paddingBottom: '5px' }}><strong>Price:</strong> ₦{device?.fullPriceNaira.toLocaleString()}</li> */}
        </ul>

        <div className="mt-5 mb-3">
          <button className="btn btn-primary" onClick={() => onClick(device)}>Select Device</button>
        </div>
      </div>
    </div>
  );
};

export default OxygenDeviceCard;
